import { render, staticRenderFns } from "./closeWhite.vue?vue&type=template&id=16056888&"
import script from "./closeWhite.vue?vue&type=script&lang=ts&"
export * from "./closeWhite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports